import { NotificationsState } from "./types";

export const INITIAL_STATE: NotificationsState = {
  messages: [],
};
